module.exports = __webpack_public_path__ + "static/1-f833fae05a7772911f281445323cf921.png";